import {defineStore} from 'pinia'
import api from '@/services/api'

export const useEmailEventsStore = defineStore('emailEvents', {
    state: () => ({
        promises: {},
    }),
    
    actions: {
        get(emailMessageId) {
            if (!this.promises[emailMessageId]) {
                const promise = api
                    .get('api/component/email_event', {
                        params: {
                            fields: ['event', 'recipient', 'eventDate', 'eventData'],
                            messageId: emailMessageId,
                            sort: '-eventDate',
                        },
                    })
                    .then(o => o.data.items)
                
                this.promises[emailMessageId] = promise
            }
            
            return this.promises[emailMessageId]
        },
    },
})